<div class="header-c">
    {{name}} Lts {{formatName(type)}}
    <!-- <epy-tooltip placement="top" style="width: 18px;display: inline-block;">
        <span class="difference" slot="trigger">
            <i class="fa fa-info-circle info" aria-hidden="true"></i>
        </span>
        Precio de venta promedio diario reportado a la CRE por estación.
    </epy-tooltip> -->
</div>
<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="flex-item"
    *ngIf="reqst===2">
    <div>
        <highcharts-chart class="chart" id="mychart1" [Highcharts]="Highcharts" [options]="chartOptions"></highcharts-chart>
    </div>
</div>